import React from 'react';
import PropTypes from 'prop-types';
import './BreadcrumbNumberCircle.scss';

const BreadcrumbNumberCircle = ({
  number,
  title,
  active,
  id,
}) => (
  <div
    id={id}
    className={`tab ${active ? 'active' : ''}`}
  >
    <span className="circle">{number}</span>
    {title}
  </div>
);

BreadcrumbNumberCircle.defaultProps = {
  number: 0,
  active: false,
  title: '',
  id: '',
};

BreadcrumbNumberCircle.propTypes = {
  number: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  title: PropTypes.string,
  active: PropTypes.bool,
  id: PropTypes.string,
};

export default BreadcrumbNumberCircle;
